import { Link } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Error loading settings:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer data-testid="footer" className="bg-secondary border-t border-border mt-24">
      <div className="px-6 md:px-12 lg:px-24 py-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <Building2 className="w-6 h-6 text-primary" />
              <span className="text-xl font-serif font-bold tracking-tight">
                {settings?.agency_name || "ARYA REAL ESTATE"}
              </span>
            </div>
            <p className="text-sm text-muted-foreground">
              Votre partenaire immobilier de confiance en Belgique depuis 2024.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm uppercase tracking-widest font-semibold">Contact</h3>
            <div className="space-y-2 text-sm text-muted-foreground">
              <p>{settings?.contact_address || "Avenue Louise 123, 1050 Bruxelles, Belgique"}</p>
              <p>Tél: {settings?.contact_phone || "+32 2 123 45 67"}</p>
              <p>Email: {settings?.contact_email || "contact@arya-realestate.be"}</p>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm uppercase tracking-widest font-semibold">Liens Rapides</h3>
            <div className="space-y-2">
              <Link to="/mentions-legales" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                Mentions Légales
              </Link>
              <Link to="/properties" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                Nos Biens
              </Link>
              <Link to="/rental-management" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                Gestion Locative
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border text-center text-sm text-muted-foreground">
          <p>© 2026 {settings?.agency_name || "ARYA REAL ESTATE"} - Tous droits réservés | N° IPI: {settings?.legal_ipi_number || "BE123456789"}</p>
        </div>
      </div>
    </footer>
  );
};